<template>
    <b-container fluid>
        <app-supervision-activity-header>Minutas</app-supervision-activity-header>
        <b-row>
            <b-col>
                <app-note-form ref="notebookForm" :geolocation="true" :on-save="onSaveNote" :the-client-id="supervisionClient.id"></app-note-form>
            </b-col>
        </b-row>
        <b-row class="justify-content-end">
            <b-col cols="12" md="3" lg="2">
                <b-btn block variant="confirm" @click="saveNote"><i class="fa fa-save"></i> Guardar Minuta</b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import NoteForm from '../../Vigilance/NoteBook/NoteBookPage/NoteForm';
import SupervisionActivityHeader from '../SupervisionActivityHeader';
import { mapGetters } from 'vuex';
export default {
    components: {
        appNoteForm: NoteForm,
        appSupervisionActivityHeader: SupervisionActivityHeader
    },
    computed: {
        ...mapGetters(['supervisionClient'])
    },
    methods: {
        saveNote() {
            this.$refs.notebookForm.saveNote();
        },
        onSaveNote() {
            this.$router.push({ name: 'supervisionIndexPage' });
        }
    }
}
</script>